import React, { useEffect } from "react";
import ContactTemplate from "../../Templetes/Contact/Contact.template";

const ContactPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Contact";
  }, []);
  return <ContactTemplate />;
};

export default ContactPage;
